import {
  PropsWithChildren,
  useMemo,
  createContext,
  useContext,
} from 'react';
import { BrokerageSummary, useBrokerages } from '.';

export type BrokeragesContextType = {
  brokeragesSummary: BrokerageSummary[],
  fetchBrokerages(): Promise<void>,
  lastRetrieved?: Date,
  isFetchingBrokerages: boolean,
}

const defaultBrokeragesContext: BrokeragesContextType = {
  brokeragesSummary: [],
  fetchBrokerages: async () => { },
  lastRetrieved: new Date(),
  isFetchingBrokerages: false,
};

export const BrokeragesContext = createContext<BrokeragesContextType>(
  defaultBrokeragesContext,
);

export function useBrokeragesContext() {
  return useContext(BrokeragesContext);
}

export function BrokeragesProvider({ children }: PropsWithChildren) {
  const brokerages = useBrokerages();

  const contextValue = useMemo(() => ({ ...brokerages }), [brokerages]);

  return (
    <BrokeragesContext.Provider value={contextValue}>
      {children}
    </BrokeragesContext.Provider>
  );
}
